'use strict';

import Autocomplete from "../Shared/Autocomplete/Autocomplete";
import { searchAddressAutocompleteFieldElements } from "./elements/searchAddressAutocompleteFieldElements";
import { xhrAddressSuggestions } from "../Map/xhr/xhrMap";
import { transformResponseToAutocompleteListFormat } from "./helpers/transformResponseToAutocompleteFormat";

const suggestionsIncludingOnline = query => {
    const online = 'online'.startsWith(query.trim().toLowerCase()) && query.trim() !== ''
        ? [{ id: 'online-offering', title: 'Online' }] : [];
    if (query.trim().length < 2 || query.trim().toLowerCase() === 'online') {
        return Promise.resolve({ response: online, query });
    }
    return xhrAddressSuggestions(query)
        .then(http => ({ response: [...online, ...http.response], query }))
        .catch(error => {
            if (online.length) return { response: online, query };
            throw error;
        });
};

export default class SearchAddressAutocompleteField extends Autocomplete
{
    constructor() {
        super(
            searchAddressAutocompleteFieldElements(),
            suggestionsIncludingOnline,
            value => {
                this.useSelectedValue(value);
            },
            null, // transformResponseToAutocompleteListFormat,
            250, // Request 250ms after typing
            false
        );
    }

    onInputChange(event) {
        if (document.activeElement !== this.elements.input) return;
        if (['ArrowUp', 'ArrowDown', 'ArrowRight', 'Escape', 'Enter'].includes(event.key)) return;
        const query = event.target.value.trim().toLowerCase();
        if (query.length < 2) {
            this.showSuggestions(query === 'o' ? [{ id: 'online-offering', title: 'Online' }] : []);
            return;
        }
        super.onInputChange(event);
    }

    handleResponse(data) {
        // Keep stale address requests from replacing the current Online suggestion.
        const query = this.elements.input.value.trim().toLowerCase();
        if (document.activeElement !== this.elements.input || data.query.trim().toLowerCase() !== query) return;
        if (query.length < 2) {
            this.showSuggestions(query === 'o' ? [{ id: 'online-offering', title: 'Online' }] : []);
            return;
        }
        super.handleResponse(data);
    }

    useSelectedValue(value) {
        this.elements.input.value = value.title;
    }
}
